import React from 'react';
import PropTypes from 'prop-types';
import { Loader, Header, Text } from '@gasbuddy/react-components';
import { useTranslation } from 'react-i18next';
import DeferredRedirect from '../DeferredRedirect';

export default function PasswordUpdateRedirect({ destination, autoRedirect }) {
  const { t } = useTranslation('auth');

  let deferredRedirect;
  if (autoRedirect) {
    deferredRedirect = <DeferredRedirect to={destination} />;
  }

  return (
    <React.Fragment>
      <Header as="h3">{t('passwordChange.passwordUpdateRedirect.title')}</Header>
      <Loader speed="slow" inline />
      <br />
      <br />
      <Text as="p">{t('passwordChange.passwordUpdateRedirect.message')}</Text>
      {deferredRedirect}
    </React.Fragment>
  );
}

PasswordUpdateRedirect.propTypes = {
  destination: PropTypes.string.isRequired,
  autoRedirect: PropTypes.bool,
};

PasswordUpdateRedirect.defaultProps = {
  autoRedirect: false,
};
